import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { ErrorPage } from '@dora/vivian';
import { AppControlContext } from '../contexts/appControl';
import * as Actions from './../store/actions/app';
import { useDispatch } from './../store/redux';

/**
 * Wrapper for the global error page component
 */
export const Component = () => {
    const appControl = Hooks.useContext(AppControlContext);
    const dispatch = useDispatch();
    return (
        <Box width="100%" height="100%" bgcolor="background.paper" borderRadius="24px">
            <ErrorPage.Component
                onCloseClick={() => {
                    dispatch(Actions.closeFromErrorAction());
                    appControl?.closeApp();
                }}
            />
        </Box>
    );
};
